// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/icons/bgImgGlobal.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow-x: auto;
  /* Allow horizontal scroll but hide scrollbar */
}

body {
  position: relative;
  background: none;
  overflow-y: scroll;
  scrollbar-width: none;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none;
}


/* add flipped background image via ::before */
body::before {
  content: "";
  position: fixed !important;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center fixed;
  background-size: cover;
  /* transform: scaleX(-1);  */
  z-index: -1;
  pointer-events: none;
}

/* For WebKit browsers - Vertical scrollbar */
body::-webkit-scrollbar {
  width: 30px;
  background-color: #2c2c2c;
}

body::-webkit-scrollbar-thumb {
  background-color: #9f9f9f;
  border-radius: 10px;
  border: 3px solid #2c2c2c;
}

body::-webkit-scrollbar-track {
  background-color: #2c2c2c;
  border-radius: 10px;
}

/* Hide horizontal scrollbar for WebKit browsers */
body::-webkit-scrollbar:horizontal {
  display: none;
}

html::-webkit-scrollbar:horizontal {
  display: none;
}

html {
  scrollbar-width: auto;
  scrollbar-color: #9f9f9f #2c2c2c;
}

/* Hide horizontal scrollbar for all elements */
*::-webkit-scrollbar:horizontal {
  display: none;
}





/* @media (min-width: 1441px) {
  body {
    max-width: 1440px; 
    margin: 0 auto;      
    padding: 0 20px;    
  }
} */

/* Fonts are now loaded via Google Fonts CDN in index.html */
/* This removes the need for local @font-face declarations and improves loading performance */


/* Button Group Specific Styles */
.MuiButtonGroup-root {
  isolation: isolate !important;
  contain: layout !important;
}

.MuiButtonGroup-grouped {
  isolation: isolate !important;
  contain: layout !important;
  position: relative !important;
  z-index: 1 !important;
}

.MuiButtonGroup-grouped:not(:last-of-type) {
  border-right: none !important;
}

.MuiButtonGroup-grouped:not(:first-of-type) {
  border-left: none !important;
}

/* Ensure button group doesn't overflow */
.MuiButtonGroup-root {
  overflow: hidden !important;
  box-sizing: border-box !important;
}

/* Prevent any potential margin collapse */
.MuiButtonGroup-root * {
  box-sizing: border-box !important;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;AACf;;;AAGA,8CAA8C;AAC9C;EACE,WAAW;EACX,0BAA0B;EAC1B,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iFAAoF;EACpF,sBAAsB;EACtB,4BAA4B;EAC5B,WAAW;EACX,oBAAoB;AACtB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA,+CAA+C;AAC/C;EACE,aAAa;AACf;;;;;;AAMA;;;;;;GAMG;;AAEH,4DAA4D;AAC5D,6FAA6F;;;AAG7F,iCAAiC;AACjC;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,yCAAyC;AACzC;EACE,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA,0CAA0C;AAC1C;EACE,iCAAiC;AACnC","sourcesContent":["* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml,\nbody {\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  overflow-x: auto;\n  /* Allow horizontal scroll but hide scrollbar */\n}\n\nbody {\n  position: relative;\n  background: none;\n  overflow-y: scroll;\n  scrollbar-width: none;\n}\n\nhtml::-webkit-scrollbar,\nbody::-webkit-scrollbar {\n  display: none;\n}\n\n\n/* add flipped background image via ::before */\nbody::before {\n  content: \"\";\n  position: fixed !important;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: url(\"../../assets/icons/bgImgGlobal.webp\") no-repeat center center fixed;\n  background-size: cover;\n  /* transform: scaleX(-1);  */\n  z-index: -1;\n  pointer-events: none;\n}\n\n/* For WebKit browsers - Vertical scrollbar */\nbody::-webkit-scrollbar {\n  width: 30px;\n  background-color: #2c2c2c;\n}\n\nbody::-webkit-scrollbar-thumb {\n  background-color: #9f9f9f;\n  border-radius: 10px;\n  border: 3px solid #2c2c2c;\n}\n\nbody::-webkit-scrollbar-track {\n  background-color: #2c2c2c;\n  border-radius: 10px;\n}\n\n/* Hide horizontal scrollbar for WebKit browsers */\nbody::-webkit-scrollbar:horizontal {\n  display: none;\n}\n\nhtml::-webkit-scrollbar:horizontal {\n  display: none;\n}\n\nhtml {\n  scrollbar-width: auto;\n  scrollbar-color: #9f9f9f #2c2c2c;\n}\n\n/* Hide horizontal scrollbar for all elements */\n*::-webkit-scrollbar:horizontal {\n  display: none;\n}\n\n\n\n\n\n/* @media (min-width: 1441px) {\n  body {\n    max-width: 1440px; \n    margin: 0 auto;      \n    padding: 0 20px;    \n  }\n} */\n\n/* Fonts are now loaded via Google Fonts CDN in index.html */\n/* This removes the need for local @font-face declarations and improves loading performance */\n\n\n/* Button Group Specific Styles */\n.MuiButtonGroup-root {\n  isolation: isolate !important;\n  contain: layout !important;\n}\n\n.MuiButtonGroup-grouped {\n  isolation: isolate !important;\n  contain: layout !important;\n  position: relative !important;\n  z-index: 1 !important;\n}\n\n.MuiButtonGroup-grouped:not(:last-of-type) {\n  border-right: none !important;\n}\n\n.MuiButtonGroup-grouped:not(:first-of-type) {\n  border-left: none !important;\n}\n\n/* Ensure button group doesn't overflow */\n.MuiButtonGroup-root {\n  overflow: hidden !important;\n  box-sizing: border-box !important;\n}\n\n/* Prevent any potential margin collapse */\n.MuiButtonGroup-root * {\n  box-sizing: border-box !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
